import React, {useState, useEffect} from 'react';
import InternationalizationProvider from '@frontend/ui-kit/internationalization/InternationalizationProvider';
import translationService, {gettext} from './translationService';

type Props = {
    children: React.ReactNode
};

const TranslationProvider = ({children}: Props) => {
    const [language, setLanguage] = useState(translationService.getLanguage());

    useEffect(() => {
        const handleLanguageChange = () => setLanguage(translationService.getLanguage());

        translationService.subscribe(handleLanguageChange);

        return () => translationService.unsubscribe(handleLanguageChange);
    }, []);

    return <InternationalizationProvider key={language} options={{gettext}}>{children}</InternationalizationProvider>;
};

export default TranslationProvider;
